import { gql } from '@apollo/client'
import { COUNTRY_CONFIG_FRAGMENT } from '@/graphql/fragments/countryConfig'
import { CountryConfig } from '@/types/countryConfig'

export interface CountryConfigDataType {
  countryConfig: CountryConfig
}

export const GET_COUNTRY_CONFIG = gql`
  query getCountryConfig {
    countryConfig {
      ...CountryConfigFragment
    }
  }
  ${COUNTRY_CONFIG_FRAGMENT}
`
